import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';
import type { Device } from '../customers/types';

type Variables = {
  pushToken: string;
  platform: string;
  appVersion: string;
  customerId?: number;
};
export type CreateDeviceResponse = {
  data: Device;
};

export const useCreateDevice = createMutation<
  CreateDeviceResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: 'v2/devices',
      method: 'POST',
      data: {
        push_token: variables.pushToken,
        platform: variables.platform,
        app_version: variables.appVersion,
        customer_id: variables.customerId,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
